import { createRouter, createWebHashHistory } from "vue-router"

import { routes } from "./routes"
import authCheck from "./authcheck"

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(authCheck)
export default router
